export const heatMetersTypeArr = ['insert15', 'sono 0.6', 'sono 1.5', 'sono 0.6 RS485', 'sono 1.5 RS485', 'sono 0.6 M-Bus', 'sono 1.5 M-Bus',];

export const aptTypeDnArr = ['15', '20', '25', '15hp', '20hp', '25hp',];

export const bvAndFilterDnArr = ['20', '25', '32',];

export const branchBalansTypeDnArr = ['MNT15', 'MSVB15']

export const partnerTypeDnArr =  ['CNT15', 'CNT20', 'CNT25', 'ASVBD15', 'ASVBD20', 'ASVBD25', 'CDT15', 'CDT20', 'CDT25',];

export const designationToCodeMap = new Map([
  ['TDU.5 DN50-2L-20-CNT15-APT15-MNT15',	'150U6301'],
  ['TDU.5 DN50-3L-20-CNT15-APT15-MNT15',	'150U6302'],
  ['TDU.5 DN50-4L-20-CNT15-APT15-MNT15',	'150U6303'],
  ['TDU.5 DN50-5L-20-CNT15-APT15-MNT15',	'150U6304'],
  ['TDU.5 DN50-6L-20-CNT15-APT15-MNT15',	'150U6305'],
  ['TDU.5 DN50-7L-20-CNT15-APT15-MNT15',	'150U6306'],
  ['TDU.5 DN50-8L-20-CNT15-APT15-MNT15',	'150U6307'],
  ['TDU.5 DN50-2L-20-CNT15-APT15-MSVB15',	'150U6308'],
  ['TDU.5 DN50-3L-20-CNT15-APT15-MSVB15',	'150U6309'],
  ['TDU.5 DN50-4L-20-CNT15-APT15-MSVB15',	'150U6310'],
  ['TDU.5 DN50-5L-20-CNT15-APT15-MSVB15',	'150U6311'],
  ['TDU.5 DN50-6L-20-CNT15-APT15-MSVB15',	'150U6312'],
  ['TDU.5 DN50-7L-20-CNT15-APT15-MSVB15',	'150U6313'],
  ['TDU.5 DN50-8L-20-CNT15-APT15-MSVB15',	'150U6314'],
  ['TDU.5 DN50-2L-25-CNT20-APT20-MNT15',	'150U6315'],
  ['TDU.5 DN50-3L-25-CNT20-APT20-MNT15',	'150U6316'],
  ['TDU.5 DN50-4L-25-CNT20-APT20-MNT15',	'150U6317'],
  ['TDU.5 DN50-5L-25-CNT20-APT20-MNT15',	'150U6318'],
  ['TDU.5 DN50-6L-25-CNT20-APT20-MNT15',	'150U6319'],
  ['TDU.5 DN50-7L-25-CNT20-APT20-MNT15',	'150U6320'],
  ['TDU.5 DN50-8L-25-CNT20-APT20-MNT15',	'150U6321'],
  ['TDU.5 DN50-2L-25-CNT20-APT20-MSVB15',	'150U6322'],
  ['TDU.5 DN50-3L-25-CNT20-APT20-MSVB15',	'150U6323'],
  ['TDU.5 DN50-4L-25-CNT20-APT20-MSVB15',	'150U6324'],
  ['TDU.5 DN50-5L-25-CNT20-APT20-MSVB15',	'150U6325'],
  ['TDU.5 DN50-6L-25-CNT20-APT20-MSVB15',	'150U6326'],
  ['TDU.5 DN50-7L-25-CNT20-APT20-MSVB15',	'150U6327'],
  ['TDU.5 DN50-8L-25-CNT20-APT20-MSVB15',	'150U6328'],
  ['TDU.5 DN50-2L-32-CNT25-APT25-MNT15',	'150U6329'],
  ['TDU.5 DN50-3L-32-CNT25-APT25-MNT15',	'150U6330'],
  ['TDU.5 DN50-4L-32-CNT25-APT25-MNT15',	'150U6331'],
  ['TDU.5 DN50-5L-32-CNT25-APT25-MNT15',	'150U6332'],
  ['TDU.5 DN50-6L-32-CNT25-APT25-MNT15',	'150U6333'],
  ['TDU.5 DN50-7L-32-CNT25-APT25-MNT15',	'150U6334'],
  ['TDU.5 DN50-8L-32-CNT25-APT25-MNT15',	'150U6335'],
  ['TDU.5 DN50-2L-32-CNT25-APT25-MSVB15',	'150U6336'],
  ['TDU.5 DN50-3L-32-CNT25-APT25-MSVB15',	'150U6337'],
  ['TDU.5 DN50-4L-32-CNT25-APT25-MSVB15',	'150U6338'],
  ['TDU.5 DN50-5L-32-CNT25-APT25-MSVB15',	'150U6339'],
  ['TDU.5 DN50-6L-32-CNT25-APT25-MSVB15',	'150U6340'],
  ['TDU.5 DN50-7L-32-CNT25-APT25-MSVB15',	'150U6341'],
  ['TDU.5 DN50-8L-32-CNT25-APT25-MSVB15',	'150U6342'],
  ['TDU.5 DN50-2R-20-CNT15-APT15-MNT15',	'150U6343'],
  ['TDU.5 DN50-3R-20-CNT15-APT15-MNT15',	'150U6344'],
  ['TDU.5 DN50-4R-20-CNT15-APT15-MNT15',	'150U6345'],
  ['TDU.5 DN50-5R-20-CNT15-APT15-MNT15',	'150U6346'],
  ['TDU.5 DN50-6R-20-CNT15-APT15-MNT15',	'150U6347'],
  ['TDU.5 DN50-7R-20-CNT15-APT15-MNT15',	'150U6348'],
  ['TDU.5 DN50-8R-20-CNT15-APT15-MNT15',	'150U6349'],
  ['TDU.5 DN50-2R-20-CNT15-APT15-MSVB15',	'150U6350'],
  ['TDU.5 DN50-3R-20-CNT15-APT15-MSVB15',	'150U6351'],
  ['TDU.5 DN50-4R-20-CNT15-APT15-MSVB15',	'150U6352'],
  ['TDU.5 DN50-5R-20-CNT15-APT15-MSVB15',	'150U6353'],
  ['TDU.5 DN50-6R-20-CNT15-APT15-MSVB15',	'150U6354'],
  ['TDU.5 DN50-7R-20-CNT15-APT15-MSVB15',	'150U6355'],
  ['TDU.5 DN50-8R-20-CNT15-APT15-MSVB15',	'150U6356'],
  ['TDU.5 DN50-2R-25-CNT20-APT20-MNT15',	'150U6357'],
  ['TDU.5 DN50-3R-25-CNT20-APT20-MNT15',	'150U6358'],
  ['TDU.5 DN50-4R-25-CNT20-APT20-MNT15',	'150U6359'],
  ['TDU.5 DN50-5R-25-CNT20-APT20-MNT15',	'150U6360'],
  ['TDU.5 DN50-6R-25-CNT20-APT20-MNT15',	'150U6361'],
  ['TDU.5 DN50-7R-25-CNT20-APT20-MNT15',	'150U6362'],
  ['TDU.5 DN50-8R-25-CNT20-APT20-MNT15',	'150U6363'],
  ['TDU.5 DN50-2R-25-CNT20-APT20-MSVB15',	'150U6364'],
  ['TDU.5 DN50-3R-25-CNT20-APT20-MSVB15',	'150U6365'],
  ['TDU.5 DN50-4R-25-CNT20-APT20-MSVB15',	'150U6366'],
  ['TDU.5 DN50-5R-25-CNT20-APT20-MSVB15',	'150U6367'],
  ['TDU.5 DN50-6R-25-CNT20-APT20-MSVB15',	'150U6368'],
  ['TDU.5 DN50-7R-25-CNT20-APT20-MSVB15',	'150U6369'],
  ['TDU.5 DN50-8R-25-CNT20-APT20-MSVB15',	'150U6370'],
  ['TDU.5 DN50-2R-32-CNT25-APT25-MNT15',	'150U6371'],
  ['TDU.5 DN50-3R-32-CNT25-APT25-MNT15',	'150U6372'],
  ['TDU.5 DN50-4R-32-CNT25-APT25-MNT15',	'150U6373'],
  ['TDU.5 DN50-5R-32-CNT25-APT25-MNT15',	'150U6374'],
  ['TDU.5 DN50-6R-32-CNT25-APT25-MNT15',	'150U6375'],
  ['TDU.5 DN50-7R-32-CNT25-APT25-MNT15',	'150U6376'],
  ['TDU.5 DN50-8R-32-CNT25-APT25-MNT15',	'150U6377'],
  ['TDU.5 DN50-2R-32-CNT25-APT25-MSVB15',	'150U6378'],
  ['TDU.5 DN50-3R-32-CNT25-APT25-MSVB15',	'150U6379'],
  ['TDU.5 DN50-4R-32-CNT25-APT25-MSVB15',	'150U6380'],
  ['TDU.5 DN50-5R-32-CNT25-APT25-MSVB15',	'150U6381'],
  ['TDU.5 DN50-6R-32-CNT25-APT25-MSVB15',	'150U6382'],
  ['TDU.5 DN50-7R-32-CNT25-APT25-MSVB15',	'150U6383'],
  ['TDU.5 DN50-8R-32-CNT25-APT25-MSVB15',	'150U6384'],
  ['TDU.5 DN50-2L-20-APT15-RLVS15',	'150U6385'],
  ['TDU.5 DN50-3L-20-APT15-RLVS15',	'150U6386'],
  ['TDU.5 DN50-4L-20-APT15-RLVS15',	'150U6387'],
  ['TDU.5 DN50-5L-20-APT15-RLVS15',	'150U6388'],
  ['TDU.5 DN50-6L-20-APT15-RLVS15',	'150U6389'],
  ['TDU.5 DN50-7L-20-APT15-RLVS15',	'150U6390'],
  ['TDU.5 DN50-8L-20-APT15-RLVS15',	'150U6391'],
  ['TDU.5 DN50-9L-20-APT15-RLVS15',	'150U6392'],
  ['TDU.5 DN50-10L-20-APT15-RLVS15',	'150U6393'],
  ['TDU.5 DN50-2L-20-APT15-USVS15',	'150U6394'],
  ['TDU.5 DN50-3L-20-APT15-USVS15',	'150U6395'],
  ['TDU.5 DN50-4L-20-APT15-USVS15',	'150U6396'],
  ['TDU.5 DN50-5L-20-APT15-USVS15',	'150U6397'],
  ['TDU.5 DN50-6L-20-APT15-USVS15',	'150U6398'],
  ['TDU.5 DN50-7L-20-APT15-USVS15',	'150U6399'],
  ['TDU.5 DN50-8L-20-APT15-USVS15',	'150U6400'],
  ['TDU.5 DN50-9L-20-APT15-USVS15',	'150U6401'],
  ['TDU.5 DN50-10L-20-APT15-USVS15',	'150U6402'],
  ['TDU.5 DN50-2L-20-APT15-MNT15',	'150U6403'],
  ['TDU.5 DN50-3L-20-APT15-MNT15',	'150U6404'],
  ['TDU.5 DN50-4L-20-APT15-MNT15',	'150U6405'],
  ['TDU.5 DN50-5L-20-APT15-MNT15',	'150U6406'],
  ['TDU.5 DN50-6L-20-APT15-MNT15',	'150U6407'],
  ['TDU.5 DN50-7L-20-APT15-MNT15',	'150U6408'],
  ['TDU.5 DN50-8L-20-APT15-MNT15',	'150U6409'],
  ['TDU.5 DN50-9L-20-APT15-MNT15',	'150U6410'],
  ['TDU.5 DN50-10L-20-APT15-MNT15',	'150U6411'],
  ['TDU.5 DN50-2L-20-APT15-MSVB15',	'150U6412'],
  ['TDU.5 DN50-3L-20-APT15-MSVB15',	'150U6413'],
  ['TDU.5 DN50-4L-20-APT15-MSVB15',	'150U6414'],
  ['TDU.5 DN50-5L-20-APT15-MSVB15',	'150U6415'],
  ['TDU.5 DN50-6L-20-APT15-MSVB15',	'150U6416'],
  ['TDU.5 DN50-7L-20-APT15-MSVB15',	'150U6417'],
  ['TDU.5 DN50-8L-20-APT15-MSVB15',	'150U6418'],
  ['TDU.5 DN50-9L-20-APT15-MSVB15',	'150U6419'],
  ['TDU.5 DN50-10L-20-APT15-MSVB15',	'150U6420'],
  ['TDU.5 DN50-2L-20-CNT15-APT15-RLVS15',	'150U6421'],
  ['TDU.5 DN50-3L-20-CNT15-APT15-RLVS15',	'150U6422'],
  ['TDU.5 DN50-4L-20-CNT15-APT15-RLVS15',	'150U6423'],
  ['TDU.5 DN50-5L-20-CNT15-APT15-RLVS15',	'150U6424'],
  ['TDU.5 DN50-6L-20-CNT15-APT15-RLVS15',	'150U6425'],
  ['TDU.5 DN50-7L-20-CNT15-APT15-RLVS15',	'150U6426'],
  ['TDU.5 DN50-8L-20-CNT15-APT15-RLVS15',	'150U6427'],
  ['TDU.5 DN50-9L-20-CNT15-APT15-RLVS15',	'150U6428'],
  ['TDU.5 DN50-10L-20-CNT15-APT15-RLVS15',	'150U6429'],
  ['TDU.5 DN50-2L-20-CNT15-APT15-USVS15',	'150U6430'],
  ['TDU.5 DN50-3L-20-CNT15-APT15-USVS15',	'150U6431'],
  ['TDU.5 DN50-4L-20-CNT15-APT15-USVS15',	'150U6432'],
  ['TDU.5 DN50-5L-20-CNT15-APT15-USVS15',	'150U6433'],
  ['TDU.5 DN50-6L-20-CNT15-APT15-USVS15',	'150U6434'],
  ['TDU.5 DN50-7L-20-CNT15-APT15-USVS15',	'150U6435'],
  ['TDU.5 DN50-8L-20-CNT15-APT15-USVS15',	'150U6436'],
  ['TDU.5 DN50-9L-20-CNT15-APT15-USVS15',	'150U6437'],
  ['TDU.5 DN50-10L-20-CNT15-APT15-USVS15',	'150U6438'],
  ['TDU.5 DN50-9L-20-CNT15-APT15-MNT15',	'150U6439'],
  ['TDU.5 DN50-10L-20-CNT15-APT15-MNT15',	'150U6440'],
  ['TDU.5 DN50-9L-20-CNT15-APT15-MSVB15',	'150U6441'],
  ['TDU.5 DN50-10L-20-CNT15-APT15-MSVB15',	'150U6442'],
  ['TDU.5 DN50-2L-25-APT20-RLVS15',	'150U6443'],
  ['TDU.5 DN50-3L-25-APT20-RLVS15',	'150U6444'],
  ['TDU.5 DN50-4L-25-APT20-RLVS15',	'150U6445'],
  ['TDU.5 DN50-5L-25-APT20-RLVS15',	'150U6446'],
  ['TDU.5 DN50-6L-25-APT20-RLVS15',	'150U6447'],
  ['TDU.5 DN50-7L-25-APT20-RLVS15',	'150U6448'],
  ['TDU.5 DN50-8L-25-APT20-RLVS15',	'150U6449'],
  ['TDU.5 DN50-9L-25-APT20-RLVS15',	'150U6450'],
  ['TDU.5 DN50-10L-25-APT20-RLVS15',	'150U6451'],
  ['TDU.5 DN50-2L-25-APT20-USVS15',	'150U6452'],
  ['TDU.5 DN50-3L-25-APT20-USVS15',	'150U6453'],
  ['TDU.5 DN50-4L-25-APT20-USVS15',	'150U6454'],
  ['TDU.5 DN50-5L-25-APT20-USVS15',	'150U6455'],
  ['TDU.5 DN50-6L-25-APT20-USVS15',	'150U6456'],
  ['TDU.5 DN50-7L-25-APT20-USVS15',	'150U6457'],
  ['TDU.5 DN50-8L-25-APT20-USVS15',	'150U6458'],
  ['TDU.5 DN50-9L-25-APT20-USVS15',	'150U6459'],
  ['TDU.5 DN50-10L-25-APT20-USVS15',	'150U6460'],
  ['TDU.5 DN50-2L-25-APT20-MNT15',	'150U6461'],
  ['TDU.5 DN50-3L-25-APT20-MNT15',	'150U6462'],
  ['TDU.5 DN50-4L-25-APT20-MNT15',	'150U6463'],
  ['TDU.5 DN50-5L-25-APT20-MNT15',	'150U6464'],
  ['TDU.5 DN50-6L-25-APT20-MNT15',	'150U6465'],
  ['TDU.5 DN50-7L-25-APT20-MNT15',	'150U6466'],
  ['TDU.5 DN50-8L-25-APT20-MNT15',	'150U6467'],
  ['TDU.5 DN50-9L-25-APT20-MNT15',	'150U6468'],
  ['TDU.5 DN50-10L-25-APT20-MNT15',	'150U6469'],
  ['TDU.5 DN50-2L-25-APT20-MSVB15',	'150U6470'],
  ['TDU.5 DN50-3L-25-APT20-MSVB15',	'150U6471'],
  ['TDU.5 DN50-4L-25-APT20-MSVB15',	'150U6472'],
  ['TDU.5 DN50-5L-25-APT20-MSVB15',	'150U6473'],
  ['TDU.5 DN50-6L-25-APT20-MSVB15',	'150U6474'],
  ['TDU.5 DN50-7L-25-APT20-MSVB15',	'150U6475'],
  ['TDU.5 DN50-8L-25-APT20-MSVB15',	'150U6476'],
  ['TDU.5 DN50-9L-25-APT20-MSVB15',	'150U6477'],
  ['TDU.5 DN50-10L-25-APT20-MSVB15',	'150U6478'],
  ['TDU.5 DN50-2L-25-CNT20-APT20-RLVS15',	'150U6479'],
  ['TDU.5 DN50-3L-25-CNT20-APT20-RLVS15',	'150U6480'],
  ['TDU.5 DN50-4L-25-CNT20-APT20-RLVS15',	'150U6481'],
  ['TDU.5 DN50-5L-25-CNT20-APT20-RLVS15',	'150U6482'],
  ['TDU.5 DN50-6L-25-CNT20-APT20-RLVS15',	'150U6483'],
  ['TDU.5 DN50-7L-25-CNT20-APT20-RLVS15',	'150U6484'],
  ['TDU.5 DN50-8L-25-CNT20-APT20-RLVS15',	'150U6485'],
  ['TDU.5 DN50-9L-25-CNT20-APT20-RLVS15',	'150U6486'],
  ['TDU.5 DN50-10L-25-CNT20-APT20-RLVS15',	'150U6487'],
  ['TDU.5 DN50-2L-25-CNT20-APT20-USVS15',	'150U6488'],
  ['TDU.5 DN50-3L-25-CNT20-APT20-USVS15',	'150U6489'],
  ['TDU.5 DN50-4L-25-CNT20-APT20-USVS15',	'150U6490'],
  ['TDU.5 DN50-5L-25-CNT20-APT20-USVS15',	'150U6491'],
  ['TDU.5 DN50-6L-25-CNT20-APT20-USVS15',	'150U6492'],
  ['TDU.5 DN50-7L-25-CNT20-APT20-USVS15',	'150U6493'],
  ['TDU.5 DN50-8L-25-CNT20-APT20-USVS15',	'150U6494'],
  ['TDU.5 DN50-9L-25-CNT20-APT20-USVS15',	'150U6495'],
  ['TDU.5 DN50-10L-25-CNT20-APT20-USVS15',	'150U6496'],
  ['TDU.5 DN50-9L-25-CNT20-APT20-MNT15',	'150U6497'],
  ['TDU.5 DN50-10L-25-CNT20-APT20-MNT15',	'150U6498'],
  ['TDU.5 DN50-9L-25-CNT20-APT20-MSVB15',	'150U6499'],
  ['TDU.5 DN50-10L-25-CNT20-APT20-MSVB15',	'150U6500'],
  ['TDU.5 DN50-2L-32-APT25-RLVS15',	'150U6501'],
  ['TDU.5 DN50-3L-32-APT25-RLVS15',	'150U6502'],
  ['TDU.5 DN50-4L-32-APT25-RLVS15',	'150U6503'],
  ['TDU.5 DN50-5L-32-APT25-RLVS15',	'150U6504'],
  ['TDU.5 DN50-6L-32-APT25-RLVS15',	'150U6505'],
  ['TDU.5 DN50-7L-32-APT25-RLVS15',	'150U6506'],
  ['TDU.5 DN50-8L-32-APT25-RLVS15',	'150U6507'],
  ['TDU.5 DN50-9L-32-APT25-RLVS15',	'150U6508'],
  ['TDU.5 DN50-10L-32-APT25-RLVS15',	'150U6509'],
  ['TDU.5 DN50-2L-32-APT25-USVS15',	'150U6510'],
  ['TDU.5 DN50-3L-32-APT25-USVS15',	'150U6511'],
  ['TDU.5 DN50-4L-32-APT25-USVS15',	'150U6512'],
  ['TDU.5 DN50-5L-32-APT25-USVS15',	'150U6513'],
  ['TDU.5 DN50-6L-32-APT25-USVS15',	'150U6514'],
  ['TDU.5 DN50-7L-32-APT25-USVS15',	'150U6515'],
  ['TDU.5 DN50-8L-32-APT25-USVS15',	'150U6516'],
  ['TDU.5 DN50-9L-32-APT25-USVS15',	'150U6517'],
  ['TDU.5 DN50-10L-32-APT25-USVS15',	'150U6518'],
  ['TDU.5 DN50-2L-32-APT25-MNT15',	'150U6519'],
  ['TDU.5 DN50-3L-32-APT25-MNT15',	'150U6520'],
  ['TDU.5 DN50-4L-32-APT25-MNT15',	'150U6521'],
  ['TDU.5 DN50-5L-32-APT25-MNT15',	'150U6522'],
  ['TDU.5 DN50-6L-32-APT25-MNT15',	'150U6523'],
  ['TDU.5 DN50-7L-32-APT25-MNT15',	'150U6524'],
  ['TDU.5 DN50-8L-32-APT25-MNT15',	'150U6525'],
  ['TDU.5 DN50-9L-32-APT25-MNT15',	'150U6526'],
  ['TDU.5 DN50-10L-32-APT25-MNT15',	'150U6527'],
  ['TDU.5 DN50-2L-32-APT25-MSVB15',	'150U6528'],
  ['TDU.5 DN50-3L-32-APT25-MSVB15',	'150U6529'],
  ['TDU.5 DN50-4L-32-APT25-MSVB15',	'150U6530'],
  ['TDU.5 DN50-5L-32-APT25-MSVB15',	'150U6531'],
  ['TDU.5 DN50-6L-32-APT25-MSVB15',	'150U6532'],
  ['TDU.5 DN50-7L-32-APT25-MSVB15',	'150U6533'],
  ['TDU.5 DN50-8L-32-APT25-MSVB15',	'150U6534'],
  ['TDU.5 DN50-9L-32-APT25-MSVB15',	'150U6535'],
  ['TDU.5 DN50-10L-32-APT25-MSVB15',	'150U6536'],
  ['TDU.5 DN50-2L-32-CNT25-APT25-RLVS15',	'150U6537'],
  ['TDU.5 DN50-3L-32-CNT25-APT25-RLVS15',	'150U6538'],
  ['TDU.5 DN50-4L-32-CNT25-APT25-RLVS15',	'150U6539'],
  ['TDU.5 DN50-5L-32-CNT25-APT25-RLVS15',	'150U6540'],
  ['TDU.5 DN50-6L-32-CNT25-APT25-RLVS15',	'150U6541'],
  ['TDU.5 DN50-7L-32-CNT25-APT25-RLVS15',	'150U6542'],
  ['TDU.5 DN50-8L-32-CNT25-APT25-RLVS15',	'150U6543'],
  ['TDU.5 DN50-9L-32-CNT25-APT25-RLVS15',	'150U6544'],
  ['TDU.5 DN50-10L-32-CNT25-APT25-RLVS15',	'150U6545'],
  ['TDU.5 DN50-2L-32-CNT25-APT25-USVS15',	'150U6546'],
  ['TDU.5 DN50-3L-32-CNT25-APT25-USVS15',	'150U6547'],
  ['TDU.5 DN50-4L-32-CNT25-APT25-USVS15',	'150U6548'],
  ['TDU.5 DN50-5L-32-CNT25-APT25-USVS15',	'150U6549'],
  ['TDU.5 DN50-6L-32-CNT25-APT25-USVS15',	'150U6550'],
  ['TDU.5 DN50-7L-32-CNT25-APT25-USVS15',	'150U6551'],
  ['TDU.5 DN50-8L-32-CNT25-APT25-USVS15',	'150U6552'],
  ['TDU.5 DN50-9L-32-CNT25-APT25-USVS15',	'150U6553'],
  ['TDU.5 DN50-10L-32-CNT25-APT25-USVS15',	'150U6554'],
  ['TDU.5 DN50-9L-32-CNT25-APT25-MNT15',	'150U6555'],
  ['TDU.5 DN50-10L-32-CNT25-APT25-MNT15',	'150U6556'],
  ['TDU.5 DN50-9L-32-CNT25-APT25-MSVB15',	'150U6557'],
  ['TDU.5 DN50-10L-32-CNT25-APT25-MSVB15',	'150U6558'],
  ['TDU.5 DN50-2R-20-APT15-RLVS15',	'150U6559'],
  ['TDU.5 DN50-3R-20-APT15-RLVS15',	'150U6560'],
  ['TDU.5 DN50-4R-20-APT15-RLVS15',	'150U6561'],
  ['TDU.5 DN50-5R-20-APT15-RLVS15',	'150U6562'],
  ['TDU.5 DN50-6R-20-APT15-RLVS15',	'150U6563'],
  ['TDU.5 DN50-7R-20-APT15-RLVS15',	'150U6564'],
  ['TDU.5 DN50-8R-20-APT15-RLVS15',	'150U6565'],
  ['TDU.5 DN50-9R-20-APT15-RLVS15',	'150U6566'],
  ['TDU.5 DN50-10R-20-APT15-RLVS15',	'150U6567'],
  ['TDU.5 DN50-2R-20-APT15-USVS15',	'150U6568'],
  ['TDU.5 DN50-3R-20-APT15-USVS15',	'150U6569'],
  ['TDU.5 DN50-4R-20-APT15-USVS15',	'150U6570'],
  ['TDU.5 DN50-5R-20-APT15-USVS15',	'150U6571'],
  ['TDU.5 DN50-6R-20-APT15-USVS15',	'150U6572'],
  ['TDU.5 DN50-7R-20-APT15-USVS15',	'150U6573'],
  ['TDU.5 DN50-8R-20-APT15-USVS15',	'150U6574'],
  ['TDU.5 DN50-9R-20-APT15-USVS15',	'150U6575'],
  ['TDU.5 DN50-10R-20-APT15-USVS15',	'150U6576'],
  ['TDU.5 DN50-2R-20-APT15-MNT15',	'150U6577'],
  ['TDU.5 DN50-3R-20-APT15-MNT15',	'150U6578'],
  ['TDU.5 DN50-4R-20-APT15-MNT15',	'150U6579'],
  ['TDU.5 DN50-5R-20-APT15-MNT15',	'150U6580'],
  ['TDU.5 DN50-6R-20-APT15-MNT15',	'150U6581'],
  ['TDU.5 DN50-7R-20-APT15-MNT15',	'150U6582'],
  ['TDU.5 DN50-8R-20-APT15-MNT15',	'150U6583'],
  ['TDU.5 DN50-9R-20-APT15-MNT15',	'150U6584'],
  ['TDU.5 DN50-10R-20-APT15-MNT15',	'150U6585'],
  ['TDU.5 DN50-2R-20-APT15-MSVB15',	'150U6586'],
  ['TDU.5 DN50-3R-20-APT15-MSVB15',	'150U6587'],
  ['TDU.5 DN50-4R-20-APT15-MSVB15',	'150U6588'],
  ['TDU.5 DN50-5R-20-APT15-MSVB15',	'150U6589'],
  ['TDU.5 DN50-6R-20-APT15-MSVB15',	'150U6590'],
  ['TDU.5 DN50-7R-20-APT15-MSVB15',	'150U6591'],
  ['TDU.5 DN50-8R-20-APT15-MSVB15',	'150U6592'],
  ['TDU.5 DN50-9R-20-APT15-MSVB15',	'150U6593'],
  ['TDU.5 DN50-10R-20-APT15-MSVB15',	'150U6594'],
  ['TDU.5 DN50-2R-20-CNT15-APT15-RLVS15',	'150U6595'],
  ['TDU.5 DN50-3R-20-CNT15-APT15-RLVS15',	'150U6596'],
  ['TDU.5 DN50-4R-20-CNT15-APT15-RLVS15',	'150U6597'],
  ['TDU.5 DN50-5R-20-CNT15-APT15-RLVS15',	'150U6598'],
  ['TDU.5 DN50-6R-20-CNT15-APT15-RLVS15',	'150U6599'],
  ['TDU.5 DN50-7R-20-CNT15-APT15-RLVS15',	'150U6600'],
  ['TDU.5 DN50-8R-20-CNT15-APT15-RLVS15',	'150U6601'],
  ['TDU.5 DN50-9R-20-CNT15-APT15-RLVS15',	'150U6602'],
  ['TDU.5 DN50-10R-20-CNT15-APT15-RLVS15',	'150U6603'],
  ['TDU.5 DN50-2R-20-CNT15-APT15-USVS15',	'150U6604'],
  ['TDU.5 DN50-3R-20-CNT15-APT15-USVS15',	'150U6605'],
  ['TDU.5 DN50-4R-20-CNT15-APT15-USVS15',	'150U6606'],
  ['TDU.5 DN50-5R-20-CNT15-APT15-USVS15',	'150U6607'],
  ['TDU.5 DN50-6R-20-CNT15-APT15-USVS15',	'150U6608'],
  ['TDU.5 DN50-7R-20-CNT15-APT15-USVS15',	'150U6609'],
  ['TDU.5 DN50-8R-20-CNT15-APT15-USVS15',	'150U6610'],
  ['TDU.5 DN50-9R-20-CNT15-APT15-USVS15',	'150U6611'],
  ['TDU.5 DN50-10R-20-CNT15-APT15-USVS15',	'150U6612'],
  ['TDU.5 DN50-9R-20-CNT15-APT15-MNT15',	'150U6613'],
  ['TDU.5 DN50-10R-20-CNT15-APT15-MNT15',	'150U6614'],
  ['TDU.5 DN50-9R-20-CNT15-APT15-MSVB15',	'150U6615'],
  ['TDU.5 DN50-10R-20-CNT15-APT15-MSVB15',	'150U6616'],
  ['TDU.5 DN50-2R-25-APT20-RLVS15',	'150U6617'],
  ['TDU.5 DN50-3R-25-APT20-RLVS15',	'150U6618'],
  ['TDU.5 DN50-4R-25-APT20-RLVS15',	'150U6619'],
  ['TDU.5 DN50-5R-25-APT20-RLVS15',	'150U6620'],
  ['TDU.5 DN50-6R-25-APT20-RLVS15',	'150U6621'],
  ['TDU.5 DN50-7R-25-APT20-RLVS15',	'150U6622'],
  ['TDU.5 DN50-8R-25-APT20-RLVS15',	'150U6623'],
  ['TDU.5 DN50-9R-25-APT20-RLVS15',	'150U6624'],
  ['TDU.5 DN50-10R-25-APT20-RLVS15',	'150U6625'],
  ['TDU.5 DN50-2R-25-APT20-USVS15',	'150U6626'],
  ['TDU.5 DN50-3R-25-APT20-USVS15',	'150U6627'],
  ['TDU.5 DN50-4R-25-APT20-USVS15',	'150U6628'],
  ['TDU.5 DN50-5R-25-APT20-USVS15',	'150U6629'],
  ['TDU.5 DN50-6R-25-APT20-USVS15',	'150U6630'],
  ['TDU.5 DN50-7R-25-APT20-USVS15',	'150U6631'],
  ['TDU.5 DN50-8R-25-APT20-USVS15',	'150U6632'],
  ['TDU.5 DN50-9R-25-APT20-USVS15',	'150U6633'],
  ['TDU.5 DN50-10R-25-APT20-USVS15',	'150U6634'],
  ['TDU.5 DN50-2R-25-APT20-MNT15',	'150U6635'],
  ['TDU.5 DN50-3R-25-APT20-MNT15',	'150U6636'],
  ['TDU.5 DN50-4R-25-APT20-MNT15',	'150U6637'],
  ['TDU.5 DN50-5R-25-APT20-MNT15',	'150U6638'],
  ['TDU.5 DN50-6R-25-APT20-MNT15',	'150U6639'],
  ['TDU.5 DN50-7R-25-APT20-MNT15',	'150U6640'],
  ['TDU.5 DN50-8R-25-APT20-MNT15',	'150U6641'],
  ['TDU.5 DN50-9R-25-APT20-MNT15',	'150U6642'],
  ['TDU.5 DN50-10R-25-APT20-MNT15',	'150U6643'],
  ['TDU.5 DN50-2R-25-APT20-MSVB15',	'150U6644'],
  ['TDU.5 DN50-3R-25-APT20-MSVB15',	'150U6645'],
  ['TDU.5 DN50-4R-25-APT20-MSVB15',	'150U6646'],
  ['TDU.5 DN50-5R-25-APT20-MSVB15',	'150U6647'],
  ['TDU.5 DN50-6R-25-APT20-MSVB15',	'150U6648'],
  ['TDU.5 DN50-7R-25-APT20-MSVB15',	'150U6649'],
  ['TDU.5 DN50-8R-25-APT20-MSVB15',	'150U6650'],
  ['TDU.5 DN50-9R-25-APT20-MSVB15',	'150U6651'],
  ['TDU.5 DN50-10R-25-APT20-MSVB15',	'150U6652'],
  ['TDU.5 DN50-2R-25-CNT20-APT20-RLVS15',	'150U6653'],
  ['TDU.5 DN50-3R-25-CNT20-APT20-RLVS15',	'150U6654'],
  ['TDU.5 DN50-4R-25-CNT20-APT20-RLVS15',	'150U6655'],
  ['TDU.5 DN50-5R-25-CNT20-APT20-RLVS15',	'150U6656'],
  ['TDU.5 DN50-6R-25-CNT20-APT20-RLVS15',	'150U6657'],
  ['TDU.5 DN50-7R-25-CNT20-APT20-RLVS15',	'150U6658'],
  ['TDU.5 DN50-8R-25-CNT20-APT20-RLVS15',	'150U6659'],
  ['TDU.5 DN50-9R-25-CNT20-APT20-RLVS15',	'150U6660'],
  ['TDU.5 DN50-10R-25-CNT20-APT20-RLVS15',	'150U6661'],
  ['TDU.5 DN50-2R-25-CNT20-APT20-USVS15',	'150U6662'],
  ['TDU.5 DN50-3R-25-CNT20-APT20-USVS15',	'150U6663'],
  ['TDU.5 DN50-4R-25-CNT20-APT20-USVS15',	'150U6664'],
  ['TDU.5 DN50-5R-25-CNT20-APT20-USVS15',	'150U6665'],
  ['TDU.5 DN50-6R-25-CNT20-APT20-USVS15',	'150U6666'],
  ['TDU.5 DN50-7R-25-CNT20-APT20-USVS15',	'150U6667'],
  ['TDU.5 DN50-8R-25-CNT20-APT20-USVS15',	'150U6668'],
  ['TDU.5 DN50-9R-25-CNT20-APT20-USVS15',	'150U6669'],
  ['TDU.5 DN50-10R-25-CNT20-APT20-USVS15',	'150U6670'],
  ['TDU.5 DN50-9R-25-CNT20-APT20-MNT15',	'150U6671'],
  ['TDU.5 DN50-10R-25-CNT20-APT20-MNT15',	'150U6672'],
  ['TDU.5 DN50-9R-25-CNT20-APT20-MSVB15',	'150U6673'],
  ['TDU.5 DN50-10R-25-CNT20-APT20-MSVB15',	'150U6674'],
  ['TDU.5 DN50-2R-32-APT25-RLVS15',	'150U6675'],
  ['TDU.5 DN50-3R-32-APT25-RLVS15',	'150U6676'],
  ['TDU.5 DN50-4R-32-APT25-RLVS15',	'150U6677'],
  ['TDU.5 DN50-5R-32-APT25-RLVS15',	'150U6678'],
  ['TDU.5 DN50-6R-32-APT25-RLVS15',	'150U6679'],
  ['TDU.5 DN50-7R-32-APT25-RLVS15',	'150U6680'],
  ['TDU.5 DN50-8R-32-APT25-RLVS15',	'150U6681'],
  ['TDU.5 DN50-9R-32-APT25-RLVS15',	'150U6682'],
  ['TDU.5 DN50-10R-32-APT25-RLVS15',	'150U6683'],
  ['TDU.5 DN50-2R-32-APT25-USVS15',	'150U6684'],
  ['TDU.5 DN50-3R-32-APT25-USVS15',	'150U6685'],
  ['TDU.5 DN50-4R-32-APT25-USVS15',	'150U6686'],
  ['TDU.5 DN50-5R-32-APT25-USVS15',	'150U6687'],
  ['TDU.5 DN50-6R-32-APT25-USVS15',	'150U6688'],
  ['TDU.5 DN50-7R-32-APT25-USVS15',	'150U6689'],
  ['TDU.5 DN50-8R-32-APT25-USVS15',	'150U6690'],
  ['TDU.5 DN50-9R-32-APT25-USVS15',	'150U6691'],
  ['TDU.5 DN50-10R-32-APT25-USVS15',	'150U6692'],
  ['TDU.5 DN50-2R-32-APT25-MNT15',	'150U6693'],
  ['TDU.5 DN50-3R-32-APT25-MNT15',	'150U6694'],
  ['TDU.5 DN50-4R-32-APT25-MNT15',	'150U6695'],
  ['TDU.5 DN50-5R-32-APT25-MNT15',	'150U6696'],
  ['TDU.5 DN50-6R-32-APT25-MNT15',	'150U6697'],
  ['TDU.5 DN50-7R-32-APT25-MNT15',	'150U6698'],
  ['TDU.5 DN50-8R-32-APT25-MNT15',	'150U6699'],
  ['TDU.5 DN50-9R-32-APT25-MNT15',	'150U6700'],
  ['TDU.5 DN50-10R-32-APT25-MNT15',	'150U6701'],
  ['TDU.5 DN50-2R-32-APT25-MSVB15',	'150U6702'],
  ['TDU.5 DN50-3R-32-APT25-MSVB15',	'150U6703'],
  ['TDU.5 DN50-4R-32-APT25-MSVB15',	'150U6704'],
  ['TDU.5 DN50-5R-32-APT25-MSVB15',	'150U6705'],
  ['TDU.5 DN50-6R-32-APT25-MSVB15',	'150U6706'],
  ['TDU.5 DN50-8R-32-APT25-MSVB15',	'150U6707'],
  ['TDU.5 DN50-9R-32-APT25-MSVB15',	'150U6708'],
  ['TDU.5 DN50-10R-32-APT25-MSVB15',	'150U6709'],
  ['TDU.5 DN50-2R-32-CNT25-APT25-RLVS15',	'150U6710'],
  ['TDU.5 DN50-3R-32-CNT25-APT25-RLVS15',	'150U6711'],
  ['TDU.5 DN50-4R-32-CNT25-APT25-RLVS15',	'150U6712'],
  ['TDU.5 DN50-5R-32-CNT25-APT25-RLVS15',	'150U6713'],
  ['TDU.5 DN50-6R-32-CNT25-APT25-RLVS15',	'150U6714'],
  ['TDU.5 DN50-7R-32-CNT25-APT25-RLVS15',	'150U6715'],
  ['TDU.5 DN50-8R-32-CNT25-APT25-RLVS15',	'150U6716'],
  ['TDU.5 DN50-9R-32-CNT25-APT25-RLVS15',	'150U6717'],
  ['TDU.5 DN50-10R-32-CNT25-APT25-RLVS15',	'150U6718'],
  ['TDU.5 DN50-2R-32-CNT25-APT25-USVS15',	'150U6719'],
  ['TDU.5 DN50-3R-32-CNT25-APT25-USVS15',	'150U6720'],
  ['TDU.5 DN50-4R-32-CNT25-APT25-USVS15',	'150U6721'],
  ['TDU.5 DN50-5R-32-CNT25-APT25-USVS15',	'150U6722'],
  ['TDU.5 DN50-6R-32-CNT25-APT25-USVS15',	'150U6723'],
  ['TDU.5 DN50-7R-32-CNT25-APT25-USVS15',	'150U6724'],
  ['TDU.5 DN50-8R-32-CNT25-APT25-USVS15',	'150U6725'],
  ['TDU.5 DN50-9R-32-CNT25-APT25-USVS15',	'150U6726'],
  ['TDU.5 DN50-10R-32-CNT25-APT25-USVS15',	'150U6727'],
  ['TDU.5 DN50-9R-32-CNT25-APT25-MNT15',	'150U6728'],
  ['TDU.5 DN50-10R-32-CNT25-APT25-MNT15',	'150U6729'],
  ['TDU.5 DN50-9R-32-CNT25-APT25-MSVB15',	'150U6730'],
  ['TDU.5 DN50-10R-32-CNT25-APT25-MSVB15',	'150U6731'],
]);